import {
  CustomAutoComplete,
  CustomTextArea,
  CustomTextField,
  DrawerFormSection,
  InfoTooltip,
  renderTwoLineOption,
} from '../../../common/components';
import { AUTOCOMPLETE_LISTBOX_PROPS, drawerFieldSpan } from '../../../common/styles';
import { toProjectOptions } from '../../utils/toProjectOptions';
import { toWarehouseOptions } from '../../utils/toWarehouseOptions';
import { RETURN_TEXTS as TEXTS } from '../constants/consumptionReturnTexts';

/** Datos de autorización; en recepción y consulta se conservan como solo lectura. */
const ConsumptionReturnDocumentFields = ({ form, projects, warehouses, isSaving, onChange }) => {
  const disabled = Boolean(form.uuid) || isSaving;
  const change = (event) => onChange(event.target.name, event.target.value);
  return (
    <DrawerFormSection title={TEXTS.data} action={<InfoTooltip lines={[TEXTS.info]} />}>
      <CustomAutoComplete
        label={TEXTS.project}
        name="uuid_project"
        value={form.uuid_project}
        options={toProjectOptions(projects)}
        ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
        inputPlaceholder={TEXTS.project}
        disabled={disabled}
        onChange={change}
        sx={drawerFieldSpan(6)}
      />
      <CustomAutoComplete
        label={TEXTS.warehouse}
        name="uuid_warehouse"
        value={form.uuid_warehouse}
        options={toWarehouseOptions(warehouses)}
        renderOption={renderTwoLineOption}
        inputPlaceholder={TEXTS.warehouse}
        ListboxProps={AUTOCOMPLETE_LISTBOX_PROPS}
        disabled={disabled}
        onChange={change}
        sx={drawerFieldSpan(6)}
      />
      <CustomTextField
        label={TEXTS.responsible}
        name="responsible"
        value={form.responsible}
        disabled={disabled}
        onChange={change}
        sx={drawerFieldSpan(12)}
      />
      <CustomTextArea
        label={TEXTS.reason}
        name="reason"
        value={form.reason}
        disabled={disabled}
        onChange={change}
        sx={drawerFieldSpan(12)}
      />
    </DrawerFormSection>
  );
};

export default ConsumptionReturnDocumentFields;
